<template>
  <div>
    <AdminActual />
    <v-divider class="my-10"></v-divider>
    <AdminReference />
  </div>
</template>

<script>
import AdminActual from "../components/Admin/AdminActual";
import AdminReference from "../components/Admin/AdminReference";
import firebase from "firebase/app";
import "@firebase/storage";
import "@firebase/auth";


export default {
  components: {
    AdminActual,
    AdminReference
  }
};
</script>

<style>
</style>